import { Box as ChakraBox } from '@chakra-ui/react'

export const Box = ChakraBox
